import { UserCheck } from "lucide-react";

/**
 * EmployeeStatusFilter — 3-way toggle for employee status.
 *
 * Props:
 *   value: "" (all) | "aktiv" | "inaktiv"
 *   onChange: (value: string) => void
 *   testid: string base
 *   size: 'sm' | 'md' (default md)
 */
export default function EmployeeStatusFilter({ value = "", onChange, testid = "emp-status-filter", size = "md" }) {
  const pad = size === "sm" ? "px-2 py-1 text-[10px]" : "px-3 py-1.5 text-xs";
  const items = [
    { k: "", label: "Alle", cls: "text-zinc-300", active: "bg-zinc-700 text-white" },
    { k: "aktiv", label: "Aktiv", cls: "text-emerald-400", active: "bg-emerald-600 text-white" },
    { k: "inaktiv", label: "Inaktiv", cls: "text-zinc-500", active: "bg-zinc-600 text-white" },
  ];
  return (
    <div className="inline-flex items-center gap-1.5" data-testid={testid}>
      <UserCheck className="w-3.5 h-3.5 text-zinc-500 shrink-0"/>
      <div className="inline-flex rounded border border-zinc-800 overflow-hidden bg-zinc-900">
        {items.map(it => (
          <button
            key={it.k || "all"}
            onClick={() => onChange(it.k)}
            data-testid={`${testid}-${it.k || "all"}`}
            className={`${pad} font-medium transition-colors ${value === it.k ? it.active : `hover:bg-zinc-800 ${it.cls}`}`}
          >
            {it.label}
          </button>
        ))}
      </div>
    </div>
  );
}
